import React from 'react';
import {Toolbar} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles'
import DataPaginationSmall from "../../../util/data-table/DataPaginationSmall";


const styles = (theme) => ({
  root: {
    padding: '0.25em 0.5em',
    gap: '0.5em',
    minHeight: 'auto',
    border: '1px solid #ddd',
    borderBottom: 'none',
    position:'sticky',
    left: 0,
    display:'flex',
    flexWrap:'wrap',
    backgroundColor: '#fcfcfc',
  },
});

function UsageToolbar(props) {
  const {pageItemCount, controller, itemCount, handlePageChange, handleChangeRowsPerPage, classes } = props;

  return (
      <Toolbar id="usageToolbar" className={classes.root} >
        <DataPaginationSmall
          controller={controller}
          itemsTotal={itemCount}
          pageItemCount={pageItemCount}
          handlePageChange={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage} />
      </Toolbar>
  );
}

export default withStyles(styles)(UsageToolbar);
